<ng-container *transloco="let t">
  @let report = selectedReport();

  @if (heading(); as heading) {
    <h2 class="px-[var(--protocols-inset,0px)] text-text-primary" tuiTitle="m">{{ heading }}</h2>
  }

  <div class="flex min-h-0 flex-1 flex-col" data-testid="protocols-content" [pxcSlideIn]="slideDirection()">
    <div class="flex items-center justify-between gap-3 px-[var(--protocols-inset,0px)] pb-2">
      <h5 class="min-w-0 truncate text-text-primary">{{ report.title }}</h5>
      @if (canEdit()) {
        <button
          appearance="secondary"
          class="shrink-0"
          data-testid="edit-protocol"
          size="s"
          tuiButton
          type="button"
          (click)="edit.emit()">
          {{ t('Modifier') }}
        </button>
      }
    </div>

    <div class="flex min-h-0 flex-1 flex-col border-y border-border-secondary sm:flex-row">
      <pxc-nav-list [items]="navItems()" [label]="t('Historique')" [(selectedIndex)]="selectedIndex" />

      <tui-scrollbar class="min-h-0 flex-1" tuiFade="vertical">
        <pxc-form-display
          class="block py-4 pl-2 pr-[var(--protocols-inset,0px)]"
          data-testid="protocol-display"
          formDisplayStyle="columns"
          [sections]="report.sections"
          [showAlerts]="false" />
      </tui-scrollbar>
    </div>
  </div>

  <button
    appearance="outline"
    class="me-[var(--protocols-inset,0px)] shrink-0 place-self-end"
    tuiButton
    type="button"
    (click)="closed.emit()">
    {{ t('Fermer') }}
  </button>
</ng-container>
